import { all, put, takeLatest } from "redux-saga/effects";
import { fetchAudit } from "../list/reducers";
import { auditResetPage } from "../paging/reducers";

export default function* sagas() {
	yield all([
		takeLatest('eventFilters/filterChanged', filterChanged),
		takeLatest('eventFilters/eventsChanged', filterChanged)
	]);
}

export function* filterChanged(payload: any) {
	yield put(auditResetPage());
	yield put(fetchAudit());
}
